import * as React from 'react'

import {
  FormProvider as SharedFormProvider,
  TOrderForm as TOrderFormShared,
  useFormErrorHandlerCtx,
  useFormSubmitCtx,
} from '~shared/segments/FormScreen'

import { useOrderSubmit } from '../hooks/useOrderSubmit'

export type TOrderForm = TOrderFormShared

type TProps = RequiredChildren

/**
 * Wrapper for provider of the form used in the form wizard.
 * It provides the submitOrder function, which is used to submit the order.
 * It also provides the error handler, which is used to handle the errors during the order submission.
 */
export const FormProvider: React.FC<TProps> = ({ children }) => {
  const { submitOrder } = useOrderSubmit()

  return <SharedFormProvider submitOrder={submitOrder}>{children}</SharedFormProvider>
}

export { useFormSubmitCtx, useFormErrorHandlerCtx }
